import * as React from 'react';
import styled from 'styled-components';
import { IRange, ISelectableTag } from '../../../../data/types';
import { ControlLabel } from '../../../shared/form/ControlLabel';
import { ControlSpacer } from '../../../shared/form/ControlSpacer';
import { FormContainer } from '../../../shared/form/FormContainer';
import { TagSelect } from '../../../shared/form/selects/TagsSelect';
import { TimeframeSelect } from '../../../shared/form/selects/TimeframeSelect';
import { CardHeader, CardHeaderLeft } from '../../../shared/card/CardHeader';
import { IDsiReportSettings } from '../../../../data/providers/settings/reports/dsiReportSettingsProvider';
import { Row } from '../../../layout/Row';
import { Column } from '../../../layout/Column';
import { FormSection } from '../../utils/settings/FormSection';
import { Step } from '../../../shared/form/Step';

interface IProps {
  settings: IDsiReportSettings;
  onSettingsChange: (settings: IDsiReportSettings) => void;
}

export const DSIForm = (props: IProps): React.ReactElement => {
  /**
   * @description handles change to iso tags
   * @param sTags
   * @returns
   */
  const isoTagsChangeHandler = (isoTags: ISelectableTag[]): void => {
    props.onSettingsChange({
      ...props?.settings,
      isoTags,
    });
  };

  /**
   * @description handles change to iso tags
   * @param sTags
   * @returns
   */
  const cmjTagsChangeHandler = (cmjTags: ISelectableTag[]): void => {
    props.onSettingsChange({
      ...props?.settings,
      cmjTags,
    });
  };

  /**
   * @description handle changes to timeframe
   * @param timeframe
   */
  const timeframeChangeHandler = (timeframe: IRange): void => {
    props.onSettingsChange({ ...props?.settings, timeframe });
  };

  return (
    <div style={{ padding: '10px', paddingTop: '20px' }}>
      <FormSection>
        <CardHeader>
          <CardHeaderLeft>
            <Step>1</Step>
            <h6>Select Timeframe</h6>
          </CardHeaderLeft>
        </CardHeader>
        <div style={{ padding: '10px' }}>
          <ControlSpacer>
            <TimeframeSelect
              dateRange={props.settings?.timeframe}
              onChange={timeframeChangeHandler}
            />
          </ControlSpacer>
        </div>
      </FormSection>
      <FormSection>
        <CardHeader>
          <CardHeaderLeft>
            <Step>2</Step>
            <h6>Add Tags</h6>
          </CardHeaderLeft>
        </CardHeader>
        <div style={{ padding: '10px' }}>
          <Column>
            <Row shouldCollapse>
              <LeftSide>
                <ControlLabel>CMJ Tags</ControlLabel>
                <TagSelect
                  value={props.settings?.cmjTags}
                  onChange={cmjTagsChangeHandler}
                />
              </LeftSide>
              <RightSide>
                <ControlLabel>Isometric Tags</ControlLabel>
                <TagSelect
                  value={props.settings?.isoTags}
                  onChange={isoTagsChangeHandler}
                />
              </RightSide>
            </Row>
          </Column>
        </div>
      </FormSection>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LeftSide = styled(ControlSpacer as any)`
  flex: 1;
  margin-right: 10px;
  width: 100%;
  @media (max-width: 990px) {
    margin-right: 0;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RightSide = styled(ControlSpacer as any)`
  flex: 1;
  width: 100%;
`;
